import React from 'react';

const IconHex = () => (
  <svg id="hex" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 100 100">
    <title>Hexagon</title>
    <g>
      <polygon
        stroke="var(--green)"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="50 5 11 27 11 72 50 95 89 73 89 28"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconHex;
